import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./features/user";
import utilsReducer from "./features/utils";
import companyReducer from "./features/company";
import testReducer from "./features/test";
import testFunctionReducer from "./features/test_function";
import tagReducer from "./features/tag";
import formTemplateReducer from "./features/form_template";
import reportTemplateReducer from "./features/report_template";
import organizationReducer from "./features/organization";
import breadcrumbsReducer from './features/breadcrumbsSlice';
import groupReducer from './features/group';
import groupReportReducer from './features/group_report';
import examReducer from './features/exam';
import supportReducer from "./features/support"; // Add Support Reducer
import resourcesReducer from './features/resources';
import auditReducer from "./features/audit";
import exportReducer from './features/export';
import exerciseReducer from './features/exercise';
import movementPlanReducer      from './features/movementPlan';
import hemscapSessionsReducer   from './features/hemscapSessions';
import movementReducer           from './features/movement';
import movementFunctionReducer   from './features/movementFunction';
import notificationReducer       from './features/notification';
import onboardingReducer         from './features/onboarding';
import broadcastReducer          from './features/broadcast';
import tourReducer               from './features/tour';
import examSummarySharesReducer from './features/examSummaryShares';

export const store = configureStore({
  reducer: {
    user: userReducer,
    utils: utilsReducer,
    company: companyReducer,
    organization: organizationReducer,
    test: testReducer,
    testFunction: testFunctionReducer,
    tag: tagReducer,
    group: groupReducer,
    groupReport: groupReportReducer,
    formTemplate: formTemplateReducer,
    reportTemplate: reportTemplateReducer,
    breadcrumbs: breadcrumbsReducer,
    exam: examReducer,
    support: supportReducer,
    resources: resourcesReducer,
    audit: auditReducer,
    export: exportReducer,
    exercise: exerciseReducer,
    movementPlan:        movementPlanReducer,
    hemscapSessions:     hemscapSessionsReducer,
    movements:           movementReducer,
    movementFunction:    movementFunctionReducer,
    notifications:       notificationReducer,
    onboarding:          onboardingReducer,
    broadcasts:          broadcastReducer,
    tours:               tourReducer,
    examSummaryShares:   examSummarySharesReducer,
  },
});
